<template>
  <div class="download-code" >
    <img src="./img/downloadCode.png" alt="扫码下载">
    <div class="msg">
      <p>扫一扫下载APP</p>
      <div class="appstore icon-apple"><a href="https://itunes.apple.com/cn/app/id1436118843?l=zh&ls=1&mt=8" target="_blank">App Store下载</a></div>
      <div class="android icon-anzhuo"><a href="https://a.app.qq.com/o/simple.jsp?pkgname=yjtc.yunclass" target="_blank" >Android 下载</a></div>
    </div>
  </div>
</template>

<script>
import global from '@/common/js/global'
  export default {
    data (){
      return {
        downloadUrl: global.imgUrl + '/version/yjykt_v1.0.0.apk'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
  @import '~@/styles/base.scss';
  .download-code {
    width: 370px;
    height: 160px;
    background-color: #fff;
    // background-color: red;
    box-sizing: border-box;
    box-shadow: 0 2px 2px #aaa;
    padding: 20px 0 0 20px;
    font-size: 14px;
    text-align: left;
    img {
      float: left;
    }
    .msg {
      float: left;
      margin-left: 24px;
      p {
        line-height: 1em;
      }
      div {
        width: 150px;
        height: 40px;
        border-radius: 8px;
        background-color: $sideBarBgc;
        box-sizing: border-box;
        padding-left: 10px;
        margin-top: 10px;
        color: #fff;
        line-height: 40px;
        a{
          display: inline-block;
          height: 40px;
          line-height: 44px;
          color: #fff;
          font-size: 14px;
          padding-left: 6px;
        }
      }
      .appstore,
      .android {
        position: relative;
        font-family: "iconfont" !important;
        font-size: 20px;
      }
      .iconfont {
        position: absolute;
        font-size: 20px;
        left: 8px;
        top: -2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/nav-bar/components/download-code.vue